import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: space-between;
    height: 100%;
    color: rgb(250, 235, 184);

    header {
        display: flex;
        /* width: 295px; */
        min-width: fit-content;
        height: 60px;
        align-items: center;
        justify-content: center;
        margin-bottom: 50px;
        .round {
            font-size: 30px;
            margin-right: ${ props => props.theme.spacing.small };
            color: rgb(250, 235, 184);
        }
        .category {
            height: 40px;
            font-size: 26px;
            color: rgb(250, 235, 184);
        }

        &.withTopMarging {
            margin-top: 17px;
        }
    }

    .eliminationMessage {
        font-size: 26px;
        font-weight: normal;
        margin-bottom: 105px;
        margin-top: -105px;
        color: rgb(250, 235, 184);
    }
`;